import { IconType } from 'react-icons';
import { HiOutlineDocumentText } from 'react-icons/hi';
import { TbBuildingBank } from 'react-icons/tb';
import { OrderVoucherType } from '@src/generated/graphql';

interface VoucherConfig {
  type: OrderVoucherType;
  icon: IconType;
  accentClass: string;
  iconClass: string;
  backgroundClass: string;
  intakeUrl: string;
}

const BANK_ICON = {
  icon: TbBuildingBank,
  accentClass: 'border-pink-600',
  iconClass: 'text-pink-600',
  backgroundClass: 'bg-pink-100',
};

export const VOUCHER_CONFIGS: Record<OrderVoucherType, VoucherConfig> = {
  NIF: {
    type: 'NIF',
    icon: HiOutlineDocumentText,
    accentClass: 'border-blue-600',
    iconClass: 'text-blue-600',
    backgroundClass: 'bg-blue-100',
    intakeUrl: '/orders/nif/new',
  },
  REMOTE_BANK: {
    type: 'REMOTE_BANK',
    intakeUrl: '/orders/bank/new-remote',
    ...BANK_ICON,
  },
  IN_PERSON_BANK: {
    type: 'IN_PERSON_BANK',
    intakeUrl: '/orders/bank/new-in-person',
    ...BANK_ICON,
  },
};
